type Props = {
  level: number
}

export function LevelBadge({ level }: Props) {
  return (
    <div className="inline-flex items-center rounded border border-amber-700/80 bg-amber-900/30 px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-amber-200">
      Lv {level}
    </div>
  )
}
